"use client";
import React from "react";
import VideoJS from "./VideoJS";

export type videoSource = {
  src: string;
  type: string;
};
export type videoSources = videoSource[];

export default function VideoPlayer({
  videoSrc,
  loop,
}: Readonly<{ videoSrc: videoSources; loop: boolean }>) {
  const playerRef = React.useRef(null);
  const videoJsOptions = {
    autoplay: true,
    //   muted: true,
    loop: loop,
    controls: true,
    responsive: true,
    fluid: true,
    sources: videoSrc,
  };

  const handlePlayerReady = (player: any) => {
    playerRef.current = player;
    // You can handle player events here, for example:
    player.on("waiting", () => {
      // videojs.log('player is waiting');
    });
    player.on("dispose", () => {
      playerRef.current = null;
    });
  };

  return <VideoJS options={videoJsOptions} onReady={handlePlayerReady} />;
}
